// JUST TO HANDLE REDUX LOGIC, DISPATCHES ACTIONS, ACCESSES GLOBAL STATE
// IMPORTANT	--DO NOT DO CALLS TO (API)-- PLEASE USE SERVICE FILE

import { createAsyncThunk } from '@reduxjs/toolkit';
import { getBreakByShiftId, getAllBreaksByShiftId } from './breaksService';

// FETCH A SINGLE BREAK
export const fetchBreak = createAsyncThunk('breaks/getBreakByShiftId', async ({ shiftId, breakId }) => {
  const breakData = await getBreakByShiftId(shiftId, breakId);
  return breakData;
});

// FETCH ALL BREAKS BY SHIFT ID
export const fetchBreaksByShiftId = createAsyncThunk('breaks/getBreaksByShiftId', async (shiftId) => {
  const breaksData = await getAllBreaksByShiftId(shiftId);
  return breaksData;
});
